<template>
  <TheHeader />
  <el-container>
    <el-slide class="el-slider" v-if="route.path != '/setting'">
      <TheSlider route_type="/service" />
    </el-slide>
    <el-main>
      <div class="main_content">
        <router-view v-slot="{ Component }">
          <keep-alive include="otaIndex">
            <component :is="Component" />
          </keep-alive>

        </router-view>
      </div>
    </el-main>
  </el-container>
</template>

<script>
// @ is an alias to /src
import { useRoute } from "vue-router";
import TheHeader from "@/components/common/views/TheHeader.vue";
import TheSlider from "@/components/common/views/TheSlider.vue";

export default {
  name: "Home",
  components: {
    TheHeader,
    TheSlider
  },

  setup() {
    const route = useRoute();
    return {
      route
    };
  },
};
</script>
<style lang="less" scoped>
.el-slider {
  flex-shrink: 0;
  width: 190px;
  height: 100%;
  z-index: 10;
  overflow-x: hidden;
  overflow-y: auto;
}

.home_box {
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  background: #fafafa;
}

.el-container {
  width: 100%;
  overflow: hidden;
}

.el-main {
  background: #fafafa;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 10px 0 30px 10px;
  overflow-y: auto;
  overflow-x: auto;
}

.my_breadcrumb {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  font-size: 16px;
}

.my_breadcrumb span {
  color: #777c89;
}

.main_content {
  display: inline-block;
  min-width: 1090px;
}

.go_back_btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 39px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  font-size: 12px;
  color: #676767;
  margin-right: 20px;

  .go_back_btn_icon {
    width: 20px;
    height: 20px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/chakanxiangqing_right.png) no-repeat center center;
    background-size: 6px;
    transform: rotate(180deg);
    margin-right: 6px;
  }
}

:deep(.el-drawer__close-btn) {
  transform: scale(1.5);
}
</style>